export default "__VITE_ASSET__DFka3WRY__"